exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul[data-v-01cf2e70] {\n  list-style: none;\n  display: flex;\n  padding: 0;\n}\nli[data-v-01cf2e70] {\n  padding: 5px 15px 5px 0;\n}\nli a[data-v-01cf2e70] {\n  text-decoration: none;\n  color: black;\n}\nli a[data-v-01cf2e70]:hover {\n  color: #404040;\n}\n", ""]);

// exports
